module.exports = __webpack_public_path__ + "img/Ortu.2b9efce.png";